<template>
    <div>
        <b-overlay :show="items_being_loaded" rounded="sm">
            <div v-if="items.length > 0">
                <div style="margin: 10px;">
                    Destination:
                     <b-form-select
                        v-model="picked_location"
                        :options="locations" 
                        size="sm" 
                        style="width: 150px;"
                    ></b-form-select>
                </div>

                <table style="width: 100%;">

                    <thead>
                        <tr style="background: black; color: white;">
                            
                            <td class="ipt_tdhr" v-on:click="sortby('shipped_ts')">
                                SHPD ON
                            </td>

                            <td class="ipt_tdhr" v-on:click="sortby('delivered_ts')">
                                DLVR ON
                            </td>

                            <td class="ipt_tdhr" v-on:click="sortby('truckname')">
                                TRK
                            </td>

                            <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                DEST
                            </td>

                            <td class="ipt_tdhr">
                                PRD
                            </td>
                            
                            <td class="ipt_tdhr">
                                PLD QTY
                            </td>

                            <td class="ipt_tdhr">
                                SHPD QTY
                            </td>

                            <td class="ipt_tdhr">
                                DLVR QTY
                            </td>

                            <td class="ipt_tdhr">
                                STATUS
                            </td>

                            <td class="ipt_tdhr">
                                ACTION
                            </td>
                        </tr>

                    </thead>

                    <tbody>
                        <tr v-for="item, idx in items" v-if="showRow(idx)">
                            <td class="ipt_tdr">
                                {{ item.shipped_ts }}
                            </td>

                            <td class="ipt_tdr">
                                {{ item.delivered_ts }}
                            </td>

                            <td class="ipt_tdr">
                                {{ item.truckname }}
                            </td>

                            <td class="ipt_tdr">
                                <div>{{ locationsdict[item.location_id] }}</div>
                                <div>{{ sublocationsdict[item.sublocation_id]}}</div>
                            </td>

                            <td class="ipt_tdr">
                                <div>{{ item.product_sku }}</div>
                                <div>{{ item.vendor }} ({{ item.category }})</div>
                            </td>
                            
                            <td class="ipt_tdr" style="width: 50px;">
                                {{ item.pulled_quantity }}
                            </td>

                            <td class="ipt_tdr" style="width: 50px;">
                                {{ item.shipped_quantity }}
                            </td>

                            <td class="ipt_tdr" style="width: 50px;">
                                <input v-model="item.delivered_quantity" :style="{width: '30px', 'background': (( item.delivered_quantity == null || item.delivered_quantity == '') ? '#fdcb6e' : 'orange'), 'padding': '3px', margin: 'auto', border: '1px solid #737373', 'border-radius': '2px'}"></input>
                            </td>

                            <td class="ipt_tdr" :style="{width: '120px',  background: tr_item_statuses_colors[item.status]}">
                                {{ tr_item_statuses_dict[item.status] }}
                            </td>

                            <td class="ipt_tdr">
                                <span v-if="item.status == 4">
                                    <b-badge variant="danger" style="padding: 5px; font-size: 14px; font-weight: bold; cursor: pointer;" @click="markItemAsDelivered(idx)" :disabled="actions_disabled">Mark Delivered</b-badge>
                                </span>
                                <span v-else-if="item.status == 5">
                                    <b-badge variant="primary" style="padding: 5px; font-size: 14px; font-weight: bold; cursor: pointer;" @click="markItemAsDelivered(idx)" :disabled="actions_disabled">Update</b-badge>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <b-alert v-else show variant="warning">No items in the shipped state</b-alert>

        </b-overlay>
    </div>
</template>

<script>
    import global_vars from '@/utilities/global_vars'
    import moment from 'moment'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "ShippedTransfers",
        props: ["showbacker"],
        components: {Backer},
        data: function(){
            return {
                userDetails: {properties: {}},
                tr_item_statuses: global_vars.TRANSFER_STATUSES,
                tr_item_statuses_colors: global_vars.TRANSFER_STATUSES_COLORS_DICT,
                tr_item_statuses_dict: global_vars.TRANSFER_STATUSES_DICT,
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                locsubs: [],
                items: [],
                items_being_loaded: false,
                picked_location: null,
                sort_asc: true,
                actions_disabled: false,
            }
        },
        methods: {
            showRow: function(idx){
                let item = this.items[idx];
                let allow_picked_location = this.allow_picked_location(item);

                if (allow_picked_location == true){
                    return true
                }
                else {
                    return false
                }
            },
            allow_picked_location: function(item){
                if (this.picked_location == null){
                    return true
                }
                else {
                    if (item.location_id == this.picked_location){
                        return true
                    }
                    else {
                        return false
                    }
                }
            },
            markItemAsDelivered: function(idx){
                let item = this.items[idx];
                let that = this;
                
                if (isNaN(parseInt(item.delivered_quantity))){
                    this.$vex.dialog.alert({message: "Please specify a valid numerical quantity for delivered items."});
                    return
                }
                item.delivered_quantity = parseInt(item.delivered_quantity);

                if (item.delivered_quantity > item.shipped_quantity){
                    this.$vex.dialog.alert({message: "# of items delivered cannot be more than shipped."});
                    return
                }

                let data = {
                    tr_id: item.tr_id, 
                    itemid: item.itemid, 
                    delivered_quantity: item.delivered_quantity, 
                    delivered_by: this.userDetails.username 
                }
                let path = "/api/inventory/mark_tr_item_delivered/"
                let s = function(response){
                    if (response.data.error){
                        that.$vex.dialog.alert({message: response.data.error});
                    }
                    else {
                        that.$bvToast.toast(
                            "Item successfully marked as delivered.", 
                            {title: "Succes", autoHideDelay: 1500, variant:"success"}
                        );
                        that.items[idx].status = 5;
                    }
                    that.actions_disabled = false;
                }

                let f = function(error){
                    console.log(error);
                    that.$vex.dialog.alert({message: "Error marking the item as received."});
                    that.actions_disabled = false;
                }

                this.actions_disabled = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;

                let prereqs = [
                    {
                        path:  "/api/user/get_tools_packet/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.locations.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locations.splice(0, 0, {value: null,  text: "All"});
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.sublocations = response.data.result.sublocations.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                that.locsubs = response.data.result.locsubs;

                                that.fetch_init();
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            fetch_init: function(){
                let that = this;
                let path = "/api/inventory/get_tr_items_shipped/"
                let data = {}
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.items = response.data.result
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading ready items.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
                
            }
        }
    }
</script>

<style scoped>
    .new_tr_label_box {
        display: inline-block;
        margin: 10px;
        width: auto;
        border: 1px solid;
        padding: 5px;
        font-size: 14 px;
        background: #e5ffb1;
    }

    td {
        padding: 3px;
        font-size: 14px;
    }

    select {
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ShippedTransfers.vue